<template>
  <VBlock class="delivery-tip-wrapper" :sort="Sort.space_between">
    <VBlock class="delivery-tip">
      <VSpan text="배달팁" :size="18" :color="TextColor.darkGray" :weight="TextWeight.bold" />
      <VA :onClick="onDeliveryChargeButton" :style="{ height: '23px'}">
        <VSpan
          class="detail"
          text="자세히보기"
          :size="11"
          :color="TextColor.black"
          :type="TextType.Number"
        />
      </VA>
    </VBlock>
    <VSpan
      :text="`${deliveryCharge}원`"
      :size="18"
      :weight="TextWeight.bold"
      :type="TextType.Number"
      :color="TextColor.darkGray"
    />
  </VBlock>
</template>

<script>
import VSpan, {
  TextColor,
  TextType,
  TextWeight
} from '@/presentationals/v2/components/layouts/atoms/VSpan'

import VA from '@/presentationals/v2/components/layouts/molecules/VA'
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

export default {
  name: 'DeliveryTipLayout',
  props: {
    onDeliveryChargeButton: {
      type: Function,
      required: true
    },
    deliveryCharge: {
      type: Number,
      required: true
    }
  },
  components: {
    VBlock,
    VA,
    VSpan
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor,
      TextType,
      TextWeight
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.delivery-tip-wrapper {
  margin-bottom: 2px;

  .delivery-tip {
    display: flex;
    align-content: center;
    align-items: center;
    width: auto;

    .detail {
      /* padding-top: 1px; */
      margin-left: 6px;
      border-radius: 25px;
      border: 1px solid $light-gray-4;
      background-color: $white;
      padding: 3px 8px 2px 8px;
      margin-top: 1px;
      display: inline-block !important;
      vertical-align: middle !important;
      line-height: normal !important;
    }
  }

  /* .strike-text-wrapper {
    width: auto;
    color: $light-gray-4;

    .strike-text {
      margin-right: 8px;
      color: $light-gray-4;
    }
  } */
}
</style>